"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LargeError = LargeError;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _ErrorBoundary = require("./ErrorBoundary");
var _LargeError = require("./LargeError.styled");
function LargeError(_ref) {
  var _ref$header = _ref.header,
    header = _ref$header === void 0 ? 'Something went wrong!' : _ref$header,
    _ref$description = _ref.description,
    description = _ref$description === void 0 ? '' : _ref$description;
  return /*#__PURE__*/_react["default"].createElement(_LargeError.Wrapper, null, /*#__PURE__*/_react["default"].createElement(_LargeError.StyledModal, {
    isOpen: true
  }, /*#__PURE__*/_react["default"].createElement(_LargeError.StyledModalBody, null, /*#__PURE__*/_react["default"].createElement(_LargeError.Heading, null, "Uh oh"), /*#__PURE__*/_react["default"].createElement(_ErrorBoundary.ErrorBoundary, {
    header: header,
    description: description
  }))));
}
LargeError.propTypes = {
  header: _propTypes.string,
  description: _propTypes.string
};